import type { FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import SearchInputByVenue from '@/components/SearchInputByVenue'
import { buildAssetsPath } from '@/libs/helpers/assets'
import { OrderMethod } from '@/libs/helpers/utils'
import { Grid } from '@/tbui'

const StyledGrid = styled(Grid)`
  padding: 24px;
  ${(props) =>
    props.theme.mixin.fluidRange({
      prop: 'paddingTop',
      fromSize: '40px',
      toSize: '80px',
    })};
  ${(props) =>
    props.theme.mixin.fluidRange({
      prop: 'paddingBottom',
      fromSize: '40px',
      toSize: '80px',
    })};
  ${(props) =>
    props.theme.mixin.fluidRange({
      prop: 'gap',
      fromSize: '20px',
      toSize: '34px',
    })};
`

const StyledPageTitle = styled.h1`
  font-family: ${(props) => props.theme.font.FAMILY};
  max-width: 50vw;
  margin: 0;
  ${(props) =>
    props.theme.mixin.fluidRange({
      prop: 'fontSize',
      fromSize: '18px',
      toSize: '30px',
    })};
`

const StyledBanner = styled.section`
  background-image: url(${buildAssetsPath('/images/home-bg.jpg')});
  background-position: 65% 25%;
  background-size: cover;
  margin: 0;
`

const HomeBanner: FunctionComponent<{ orderMethod: OrderMethod }> = ({ orderMethod }) => {
  const { t } = useTranslation()

  return (
    <StyledBanner>
      <StyledGrid container>
        <StyledPageTitle>{t('tbdine.title_main')}</StyledPageTitle>
        <SearchInputByVenue orderMethod={orderMethod} />
      </StyledGrid>
    </StyledBanner>
  )
}

export default HomeBanner
